const BASE = process.env.VUE_APP_REQUEST_BASE || window.origin;
export default {
    baseUrl: BASE + '/',
    basePrintUrl: BASE + '/pc/prints',
    socketUrl: BASE.replace('http', 'ws') + '/hunyuan',
};
